import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'
import styles from './index.module.less'
import Nav from './nav'
import PrimeMenu from './menu'
import usePersistStore from '@/store/persistStore'
import { useNavigate } from 'react-router-dom'
import PrimeWatermark from '@/components/watermark'

const MainLayout = () => {
  const navigate = useNavigate()
  const storeData: any = usePersistStore()
  useEffect(() => {
    if (!storeData?.token) {
      navigate('/login')
    }
  }, [storeData])
  return (
    <PrimeWatermark>
      <Layout
        style={{
          minHeight: '100vh',
          background: '#fff',
        }}
      >
        {/* 菜单栏 */}
        <Nav />
        <Layout className={styles.content}>
          <PrimeMenu />
          <div className={styles.main}>
            <Outlet />
          </div>
        </Layout>
      </Layout>
    </PrimeWatermark>
  )
}

export default MainLayout
